import { render, staticRenderFns } from "./_pagination.vue?vue&type=template&id=c9d12ea8&"
import script from "./_pagination.vue?vue&type=script&lang=js&"
export * from "./_pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports